import type { IdType } from "@ifa/utils";
import {
  getSalutationFromGender,
  parseIdCard,
  resolveBirthDateFromIdDocument,
} from "./idCardParser";

type ResolveIdDocumentAutofillParams = {
  idType?: IdType | string;
  idNumber?: string;
  currentBirthDate?: string;
  currentGender?: string;
  currentSalutation?: string;
  shouldAutoFillSalutation: boolean;
};

type IdDocumentAutofillResult = {
  birthDate?: string;
  gender?: string;
  salutation?: string;
};

export function resolveIdDocumentAutofill({
  idType,
  idNumber,
  currentBirthDate,
  currentGender,
  currentSalutation,
  shouldAutoFillSalutation,
}: ResolveIdDocumentAutofillParams): IdDocumentAutofillResult {
  const parsedResult = parseIdCard(idNumber, idType as IdType | undefined);
  if (!parsedResult.success) {
    return {};
  }

  const birthDate = resolveBirthDateFromIdDocument(
    idType,
    currentBirthDate,
    parsedResult.birthDate,
  );

  const gender = parsedResult.gender && !currentGender ? parsedResult.gender : undefined;
  const salutation = parsedResult.gender && !currentSalutation && shouldAutoFillSalutation
    ? getSalutationFromGender(parsedResult.gender)
    : undefined;

  return {
    birthDate,
    gender,
    salutation,
  };
}
